export function uniq(a) {
  return Array.from(new Set(a));
}
